import React from 'react';
import PropTypes from 'prop-types';
import { invoiceCardContainerSx, listItemSx, listTextSx } from './Invoice.styled';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

const InvoiceCard = ({ list }) => {
  return (
    <Box sx={invoiceCardContainerSx}>
      <List>
        {list.map((val, index) => (
          <ListItem key={index} sx={listItemSx}>
            <ListItemText primary={val.label} secondary={val.value} sx={listTextSx} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

InvoiceCard.propTypes = {
  list: PropTypes.array.isRequired,
};

export default InvoiceCard;
